import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { removeFromCartAction } from '../actions'
import RemoveItemButton from './RemoveItemButton'
import withPromoModal from 'components/common/hoc/withPromoModal'
import { setShowCallStorePromoExpirationNotification, setShowInRangePromoExpirationNotification } from '../PromotionExpirationModal/actions'

export default compose(
  connect(null, {
    removeFromCartAction,
    setShowCallStorePromoExpirationNotification,
    setShowInRangePromoExpirationNotification
  }),
  withPromoModal,
  withHandlers({
    removeFromCartActionHandler: ({
      removeFromCartAction,
      commerceItemId,
      rearCommerceItemId,
      product,
      setShowInRangePromoExpirationNotification,
      setShowCallStorePromoExpirationNotification
    }) => (service) => {
      removeFromCartAction(commerceItemId, rearCommerceItemId, product, service)
      setShowCallStorePromoExpirationNotification(false)
      setShowInRangePromoExpirationNotification(false)
    }
  })
)(RemoveItemButton)

